import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Box, Button } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import { useRouter } from 'next/router'
import { LandState } from 'src/@types'

interface RodeoEmptyCardProp {
  landId: number
  status: LandState
}

export default function RodeoEmptyCard({ landId, status }: RodeoEmptyCardProp) {
  const router = useRouter()

  const handleRedirectRodeo = () => {
    return router.push(`/lands/details/rodeos/${landId}`)
  }

  return (
    <Card
      className='rodeos-card'
      sx={{
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: '#D9D9D9',
        paddingTop: '45px',
        paddingBottom: '45px',
        minWidth: '250px',
        height: '495px',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Typography
            sx={{ fontSize: '18px', fontWeight: '700', textAlign: 'center', color: 'rgb(120 120 120)', mb: 5 }}
            className='cards-title'
          >
            <Translations text={`You haven't created your rodeos yet`} />
          </Typography>
          {status === LandState.COMPLETED ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', w: '100%', alignItems: 'center', mt: '24px' }}>
              <Button
                variant='outlined'
                sx={{
                  color: '#213D36',
                  width: '123px',
                  padding: '8px, 12px, 8px, 12px',
                  fontSize: '16px',
                  fontWeight: 700,
                  borderRadius: '30px',
                  border: '3px solid #213D36',
                  backgroundColor: 'white'
                }}
                onClick={handleRedirectRodeo}
              >
                <Translations text={'Load'} />
              </Button>
            </Box>
          ) : null}
        </Box>
      </CardContent>
    </Card>
  )
}
